module.exports = __webpack_public_path__ + "static/img/windows_7tiandaka.bf16a1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Course/img/windows_7tiandaka.png
// module id = XGYB
// module chunks = 1